<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/accountancy')" style="cursor: pointer">Contabilidad</li>
        <li class="breadcrumb-item active" aria-current="page">CUITF A17</li>
      </ol>
    </nav>

    <div class="container-fluid">
      <vx-card title="Reporte Cuitf Anexo 17">
        <!-- FILTROS -->
        <div class="skinny row">
          <div class="col-md-4">
              <vs-select
                placeholder="Seleccione"
                label="Tipo de reporte"
                class="w-full"
                v-model="reportType"
                >
                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in reportTypesList" />
              </vs-select>
          </div>
          <div class="col-md-2">
              <label>Año:</label>
              <vs-select
                v-model.number="year"
                class="w-full select-large"
                v-validate="'required'"
                name="sourceType"
                placeholder="Seleccione una opción"
              >
                <vs-select-item
                  :key="index"
                  :value="item"
                  :text="item"
                  v-for="(item,index) in yearsCollection"
                  class=""
                />
              </vs-select>
          </div>
          <div class="col-md-3">
            <label>Periodo:</label>
            <ul class="centerx">
              <li>
                <vs-radio color="warning" v-model.number="periodControl" vs-value="1">Mensual</vs-radio>
              </li>
              <li>
                <vs-radio color="warning" v-model.number="periodControl" vs-value="2">Trimestral</vs-radio>
              </li>
            </ul>
          </div>
          <div class="col-md-2">
            <vs-button @click.stop="getInfoForYear" color="dark" class="mt-6 mr-1">Filtrar</vs-button>
          </div>
        </div>
        <!-- FIN FILTROS -->
        <!-- TABLA -->
        <h4 class="custom-font mt-6 mb-4" v-if="isMounted">{{ currentPeriodTitle }}</h4>
        <div class="row">
        </div>
        <template v-if="isMounted">
          <vs-table :data="monthList" stripe>
            <template slot="thead">
              <vs-th></vs-th>
              <vs-th class="bold" v-for="(c, cindex) in monthCols" :key="cindex">{{ c.label }}</vs-th>
            </template>
            <template slot-scope="{data}">
              <tbody>
                <vs-tr>
                  <vs-td>Monto acumulado de financiamientos otorgados <br> desde el inicio de operaciones</vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.c1}}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Número acumulado de financiamientos otorgados <br> desde el inicio de operaciones</vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.c2}}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>
                    Número de Solicitantes de financiamiento activos <br>
                    <span class="bold">P. Físicas</span> <br>
                    <span class="bold">P. Morales</span>
                  </vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">
                    <br> {{tr.c3}} <br> {{tr.c4}}
                  </vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Número de Inversionistas activos <br>
                    <span class="bold">P. Físicas</span> <br>
                    <span class="bold">P. Morales</span>
                  </vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">
                    <br> {{tr.c5}} <br> {{tr.c6}}
                  </vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Monto de financiamientos vigentes </vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.c7}}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Número de financiamientos vigentes </vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.c8}}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Monto de financiamientos en incumplimiento </vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.c9}}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Número de financiamientos en incumplimiento </vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.c10}}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Porcentaje que representa el monto de financiamientos <br>en incumplimiento respecto del total de financiamientos </vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.c11}}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Monto de financiamientos en incumplimiento <br> por más de 90 días</vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.c12}}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Número de financiamientos en incumplimiento <br> por más de 90 días</vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.c13}}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Monto de financiamientos en cobranza </vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.c14}}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Número de financiamientos en cobranza </vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.c15}}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Rendimiento promedio anual de los financiamientos otorgado</vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.c16}}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Monto de financiamientos en incumplimiento <br> por más de 30 días</vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.c17}}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Número de financiamientos en incumplimiento <br> por más de 30 días</vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.c18}}</vs-td>
                </vs-tr>
                <vs-tr v-if="!onQuarterPeriod">
                  <vs-td>Monto recuperado de financiamientos <br> en incumplimiento (en el mes)</vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.c19}}</vs-td>
                </vs-tr>
                <vs-tr v-if="!onQuarterPeriod">
                  <vs-td>Monto de nuevos financiamientos <br> otorgados (en el mes)</vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.c20}}</vs-td>
                </vs-tr>
                <vs-tr v-if="!onQuarterPeriod">
                  <vs-td>Número de nuevos financiamientos <br> otorgados (en el mes)</vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.c21}}</vs-td>
                </vs-tr>
                <vs-tr v-if="!onQuarterPeriod">
                  <vs-td>Monto de financiamientos <br> liquidados (en el mes)</vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.c22}}</vs-td>
                </vs-tr>
                <vs-tr v-if="!onQuarterPeriod">
                  <vs-td>Número de financiamientos <br> liquidados (en el mes)</vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.c23}}</vs-td>
                </vs-tr>

                <!-- columnas de datos trimestrales -->
                <vs-tr v-if="onQuarterPeriod">
                  <vs-td>Monto recuperado de financiamientos en incumplimiento por más <br>  de 90 días durante el periodo reportado (trimestral)</vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.ct1}}</vs-td>
                </vs-tr>
                <vs-tr v-if="onQuarterPeriod">
                  <vs-td>Porcentaje que representa el monto recuperado <br>
                    durante el periodo reportado, respecto del Monto de financiamientos <br> en incumplimiento por más de 90 días (trimestral)</vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.ct2}}</vs-td>
                </vs-tr>
                <vs-tr v-if="onQuarterPeriod">
                  <vs-td>Monto de nuevos financiamientos otorgados <br> durante el periodo reportado (trimestral)</vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.ct3}}</vs-td>
                </vs-tr>
                <vs-tr v-if="onQuarterPeriod">
                  <vs-td>Número de nuevos financiamientos otorgados <br> durante el periodo reportado (trimestral)</vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.ct4}}</vs-td>
                </vs-tr>
                <vs-tr v-if="onQuarterPeriod">
                  <vs-td>Monto de financiamientos liquidados <br> durante el periodo reportado (trimestral)</vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.ct5}}</vs-td>
                </vs-tr>
                <vs-tr v-if="onQuarterPeriod">
                  <vs-td>Número de financiamientos liquidados <br> durante el periodo reportado (trimestral)</vs-td>
                  <vs-td :key="indextr" v-for="(tr, indextr) in data">{{tr.ct6}}</vs-td>
                </vs-tr>
                <!-- fin columnas de datos trimestrales -->

              </tbody>

            </template>
          </vs-table>
        </template>
      </vx-card>
    </div>
  </div>
</template>

<script>
import dateHelper from "@mixins/dateHelper";
import formatHelper from "@mixins/formatHelper";
export default {
  name: "ReportCuitfA17",
  mixins: [dateHelper, formatHelper],
  data(){
    return {
      year: 0,
      periodControl: 1,
      period: 1,
      reportType: 1,
      isMounted: false,
      yearsList: [],
      reportTypesList:[
          {text:'Prestamos personales',value:1},
          {text:'Prestamos empresariales',value:2},
      ],
      monthList: [],
      monthCols: [],
      quarterList: [],
    }
  },
  async mounted(){
    this.startLoading()
    await this.getDefaultInfo();
    this.isMounted = true
    this.stopLoading()
  },
  methods: {
    async getDefaultInfo(){
      try {
        const res = await axios.get(`/api/reports/cuitfa17/getDefault?type=${this.periodString}&report_type=${this.reportType}`);
        this.yearsList = res.data.years;
        this.year = this.yearsList[0];
        const periodInfo = res.data.default;
        this.processInfo(periodInfo);
      }
      catch (e) {
      }
    },
    async getInfoForYear(){
      this.startLoading()
      this.period = this.periodControl;
      try {
        const res = await axios.get(`/api/reports/cuitfa17/getDataForYear?type=${this.periodString}&year=${this.year}&report_type=${this.reportType}`);
        const periodInfo = res.data;
        this.processInfo(periodInfo);
      }
      catch (e) {
      }
      this.stopLoading()
    },
    processInfo(periodInfo){
      if(this.onMonthPeriod){
        this.processMonthPeriodInfo(periodInfo);
      }
      else {
        this.processQuarterPeriodInfo(periodInfo.q1, periodInfo.q2, periodInfo.q3, periodInfo.q4);
      }
    },
    processMonthPeriodInfo(months){
      this.monthList = [];
      this.monthCols = [];
      let m = 1;
      months.forEach(f => {
        this.monthCols.push({m: m, label: this.monthYearFormat(f.report_date) })
        this.monthList.push(this.setDataRow(f, m))
      });
    },
    processQuarterPeriodInfo(q1,q2,q3,q4){
      this.monthList = [];
      this.monthCols = [];
      this.monthCols.push({m: 1, label: "Q1"});
      this.monthCols.push({m: 2, label: "Q2"});
      this.monthCols.push({m: 3, label: "Q3"});
      this.monthCols.push({m: 4, label: "Q4"});
      this.monthList.push(this.setDataRow(q1, 1));
      this.monthList.push(this.setDataRow(q2, 2));
      this.monthList.push(this.setDataRow(q3, 3));
      this.monthList.push(this.setDataRow(q4, 4));
    },
    setDataRow(f, m){
      if(f == null){
        return  {
          m: m,
          c1: '-',
          c2: '-',
          c3: '-',
          c4: '-',
          c5: '-',
          c6: '-',
          c7: '-',
          c8: '-',
          c9: '-',
          c10: '-',
          c11: '-',
          c12: '-',
          c13: '-',
          c14: '-',
          c15: '-',
          c16: '-',
          c17: '-',
          c18: '-',
          c19: '-',
          c20: '-',
          c21: '-',
          c22: '-',
          c23: '-',

          ct1: '-',
          ct2: '-',
          ct3: '-',
          ct4: '-',
          ct5: '-',
          ct6: '-',
        }
      }
      return {
        m: m,
        c1: this.explicitMoneyFormat(f.monto_acumulado_financiamientos),
        c2: this.intDigitsFormat(f.num_acumulado_financiamientos),
        c3: this.intDigitsFormat(f.solicitantes_activos_pfisicas),
        c4: this.intDigitsFormat(f.solicitantes_activos_pmorales),
        c5: this.intDigitsFormat(f.inversionistas_activos_pfisicas),
        c6: this.intDigitsFormat(f.inversionistas_activos_pmorales),
        c7: this.explicitMoneyFormat(f.monto_financiamientos_vigentes),
        c8: this.intDigitsFormat(f.num_financiamientos_vigentes),
        c9: this.explicitMoneyFormat(f.monto_financiamientos_incumplimiento),
        c10: this.intDigitsFormat(f.num_financiamientos_incumplimiento),
        c11: this.decimalPercentFormat(f.prcent_financiamientos_inclumplimiento_total, 2),
        c12: this.explicitMoneyFormat(f.monto_financiamientos_incumplimiento_90d),
        c13: this.intDigitsFormat(f.num_financiamientos_incumplimiento_90d),
        c14: this.explicitMoneyFormat(f.monto_financiamientos_cobranza),
        c15: this.intDigitsFormat(f.num_financiamientos_cobranza),
        c16: this.decimalPercentFormat(f.rendimiento_financiamientos_otorgados, 2),
        c17: this.explicitMoneyFormat(f.monto_financiamientos_incumplimiento_30d),
        c18: this.intDigitsFormat(f.num_financiamientos_incumplimiento_30d),
        c19: this.explicitMoneyFormat(f.monto_recuperado_financiamientos_mes),
        c20: this.explicitMoneyFormat(f.monto_nuevos_financiamientos_mes),
        c21: this.intDigitsFormat(f.num_nuevos_financiamientos_mes),
        c22: this.explicitMoneyFormat(f.monto_financiamientos_liquidados_mes),
        c23: this.intDigitsFormat(f.num_financiamientos_liquidados_mes),

        ct1: this.explicitMoneyFormat(f.monto_recuperado_financiamientos_90d),
        ct2: this.decimalPercentFormat(f.prcent_monto_recuperado_90d, 2),
        ct3: this.explicitMoneyFormat(f.monto_nuevos_financiamientos_trimestre),
        ct4: this.intDigitsFormat(f.num_nuevos_financiamientos_trimestre),
        ct5: this.explicitMoneyFormat(f.monto_financiamientos_liquidados_trimestre),
        ct6: this.intDigitsFormat(f.num_financiamientos_liquidados_trimestre),
      }
    }
  },
  computed: {
    currentPeriodTitle(){
      if(this.onMonthPeriod){
        return `Reportes mensuales - ${this.year} (${this.reportTypesList.find(t => t.value === this.reportType).text})`;
      }
      else {
        return `Reportes trimestrales - ${this.year} (${this.reportTypesList.find(t => t.value === this.reportType).text})`;
      }
    },
    periodString(){
      return (this.period === 1) ? "month" : "quarter";
    },
    onMonthPeriod(){
      return this.period === 1;
    },
    onQuarterPeriod(){
      return this.period === 2;
    },
    montsCollection(){
      return [];
    },
    yearsCollection(){
      return this.yearsList;
    },
  }
}
</script>

<style scoped>

</style>